export const cityData = {
  '北京': [
    { title: '', content: '' }
  ]
}